import React from 'react';
import CompanyInformationOverview from 'page/Application/MyPagePartnerAdmin/CompanyInformation/CompanyInformationOverview';
import CompanyInformationEdit from 'page/Application/MyPagePartnerAdmin/CompanyInformation/CompanyInformationEdit';
import { Outlet } from 'react-router-dom';

const CompanyInformation = () => {
  return <Outlet />;
};

export default CompanyInformation;

export { CompanyInformationOverview, CompanyInformationEdit };
